import { useFormContext } from 'react-hook-form';
import { LiliError } from '@lili/lili-frontend-common';
import { useBoundStore } from '@Store/index';
import { OnboardingFormFields } from '@Types/index.ts';
import { useOwnersCenterContext } from '../context/OwnersCenterContext';
import { OwnerPercentage } from '../components/OwnerPercentage';
import { UBOManagement } from '../components/UBOManagement';
import { calculateOverallPercentage } from './ownersCenterScheme';
import type { OwnersCenterFormType } from './OwnersCenterForm.types';

export const OwnersCenterForm = () => {
  const { businessOwners, mainOwner, handleMainOwnerPercentageChange, validateTotalPercentage } =
    useOwnersCenterContext();

  const {
    formState: { errors },
    watch,
  } = useFormContext<OwnersCenterFormType>();

  const { formFieldErrors } = useBoundStore((state) => state.errorSlice);
  const mainOwnerPercentageError =
    formFieldErrors[OnboardingFormFields.OWNER_PERCENTAGE] ||
    errors[OnboardingFormFields.OWNER_PERCENTAGE]?.message;

  const totalPercentageError = errors.root?.totalPercentage?.message;

  const formValues = watch();
  const hasMoreThan25PercentOwnershipLeft = calculateOverallPercentage(formValues) <= 75;

  return (
    <div className='w-full'>
      <div className='min-h-[24px] mb-[8px]'>
        {totalPercentageError && (
          <LiliError errorMessage={totalPercentageError} data-testid='total-percentage-error' />
        )}
      </div>
      <OwnerPercentage
        ownerName={`${mainOwner.firstName} ${mainOwner.lastName}`}
        ownerIndex={1}
        errorMessage={mainOwnerPercentageError}
        canEdit={false}
        handleOnBlur={handleMainOwnerPercentageChange}
        onChangeValidate={validateTotalPercentage}
        name={OnboardingFormFields.OWNER_PERCENTAGE}
      />
      <UBOManagement
        uboList={businessOwners}
        hasMoreThan25PercentOwnershipLeft={hasMoreThan25PercentOwnershipLeft}
      />
    </div>
  );
};
